<!-- HEADER CON ICONA UTENTI -->
<div class="d-flex mb-4 position-relative">
  <div class="users-icon-wrapper text-center">
    <div class="icon-circle bg-primary bg-gradient shadow-lg">
      <i class="fas fa-users fa-2x text-white"></i>
    </div>
  </div>
</div>

<!-- LOADING -->
@if (loading) {
  <div class="text-center py-5">
    <div
      class="spinner-border spinner-border-lg text-primary shadow-lg"
      style="width: 4rem; height: 4rem"
    ></div>
    <p class="mt-3 text-muted fw-medium">Caricamento utenti...</p>
  </div>
}

<!-- TABELLA UTENTI -->
@if (!loading) {
  <div class="users-table-container position-relative mt-5">
    <div class="table-overlay"></div>

    <div
      class="table-responsive rounded-4 shadow-xl border-0 p-3"
      style="background: rgba(255, 255, 255, 0.95); backdrop-filter: blur(20px)"
    >
      <table class="table table-hover users-table mb-0 w-100">
        <thead class="table-header">
          <tr>
            <th scope="col">
              <div class="th-content">
                <i class="fas fa-user me-2 text-primary"></i>
                Nome
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <i class="fas fa-envelope me-2 text-primary"></i>
                Email
              </div>
            </th>
            <th scope="col" class="text-center">
              <div class="th-content">
                <i class="fas fa-toggle-on me-2 text-primary"></i>
                Stato
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          @for (user of users; track user.$id) {
            <tr class="user-row">
              <td class="user-name fw-semibold">{{ user.name }}</td>
              <td class="user-email">{{ user.email }}</td>
              <td class="text-center">
                <button
                  (click)="toggleUser(user)"
                  class="btn status-toggle shadow-lg border-0 rounded-3 px-4 py-2 fw-semibold position-relative overflow-hidden"
                  [ngClass]="
                    user.status
                      ? 'btn-success status-active'
                      : 'btn-outline-secondary status-inactive'
                  "
                >
                  @if (user.status) {
                    <i class="fas fa-check-circle me-2"></i>
                    <span>Abilitato</span>
                  } @else {
                    <i class="fas fa-times-circle me-2"></i>
                    <span>Disabilitato</span>
                  }

                  <div class="toggle-glow"></div>
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="3" class="text-center py-5">
                <i class="fas fa-users-slash fa-3x text-muted mb-3"></i>
                <p class="text-muted fw-medium">Nessun utente trovato</p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

<style>
  /* Icona utenti */
  .users-icon-wrapper .icon-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .users-icon-wrapper .icon-circle:hover {
    transform: scale(1.05) rotate(5deg);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4) !important;
  }

  /* Container tabella: non deve tagliare l'ombra e deve stare più in basso dell'icona */
  .users-table-container {
    position: relative;
    z-index: 1;
    overflow: visible;
    margin-top: 2.5rem; /* spazio extra per lasciare l'ombra sopra */
  }

  /* Overlay solo per mantenere il radius, senza coprire nulla */
  .table-overlay {
    position: absolute;
    inset: 0;
    background: transparent;
    pointer-events: none;
    z-index: 1;
    border-radius: 24px;
  }

  /* Tabella */
  .users-table {
    position: relative;
    z-index: 2;
  }

  .users-table .table-header {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(15px);
  }

  .users-table .table-header th {
    border: none !important;
    padding: 1.5rem 1.25rem !important;
    font-weight: 600 !important;
    color: #495057 !important;
  }

  .users-table .table-header .th-content {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .users-table tbody tr {
    transition: all 0.3s ease;
  }

  .users-table tbody tr:hover {
    background: rgba(0, 0, 0, 0.025) !important;
    transform: translateY(-1px);
  }

  .users-table .user-name {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1rem;
  }

  .users-table .user-email {
    color: #6c757d;
    font-size: 0.95rem;
  }

  /* Pulsanti toggle */
  .status-toggle {
    font-size: 0.9rem !important;
    min-width: 140px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12) !important;
  }

  .status-toggle.status-active {
    background: linear-gradient(135deg, #28a745, #20c997) !important;
  }

  .status-toggle.status-active:hover {
    transform: translateY(-3px) !important;
    box-shadow: 0 15px 40px rgba(40, 167, 69, 0.4) !important;
  }

  .status-toggle.status-inactive {
    border: 1px solid rgba(102, 126, 234, 0.3) !important;
    color: #6c757d !important;
  }

  .status-toggle.status-inactive:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.2) !important;
    border-color: rgba(102, 126, 234, 0.5) !important;
  }

  .status-toggle .toggle-glow {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  .status-toggle:hover .toggle-glow {
    left: 100%;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .users-icon-wrapper .icon-circle {
      width: 70px;
      height: 70px;
    }

    .users-table th,
    .users-table td {
      padding: 1rem 0.75rem !important;
    }

    .status-toggle {
      min-width: 120px !important;
      font-size: 0.85rem !important;
      padding: 0.6rem 1rem !important;
    }
  }
</style>
